import { render } from "./TemplateEditRolesUpdateModal.vue?vue&type=template&id=4ca4a3fa"
import script from "./TemplateEditRolesUpdateModal.vue?vue&type=script&lang=js"
export * from "./TemplateEditRolesUpdateModal.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__